import React, { useEffect, useRef, useState } from "react";

// Reveals text gradually, like someone typing in real time.
export default function TypewriterText({ text, onDone, onTick, className = "whitespace-pre-wrap break-words" }) {
  const [n, setN] = useState(0);
  const doneRef = useRef(false);

  useEffect(() => {
    const full = String(text || "");
    setN(0);
    doneRef.current = false;
    if (!full) { onDone && onDone(); return; }
    // ~2 chars per tick @ 18ms; caps total time so long answers don't crawl.
    const perTick = Math.max(2, Math.round(full.length / 300));
    let i = 0;
    const id = setInterval(() => {
      i += perTick;
      setN(i);
      onTick && onTick();
      if (i >= full.length) {
        clearInterval(id);
        if (!doneRef.current) { doneRef.current = true; onDone && onDone(); }
      }
    }, 18);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  const full = String(text || "");
  const shown = full.slice(0, n);
  return (
    <p className={className} data-testid="ai-typing-text">
      {shown}
      {n < full.length && <span className="inline-block w-[2px] h-[1em] align-[-0.15em] bg-[var(--rc-gold)] ml-0.5 animate-pulse" />}
    </p>
  );
}
